export default __webpack_public_path__ + "static/sprint_metodologia_di_sviluppo_agile_orangeloop-a42e8e4c17db493def08ac5a424c62c9.jpg";